// Vuex
import { mapGetters, mapActions, mapState } from "vuex";
// Constants
import { Constants } from "customer-sdk/constants";
const {
  CONFIG_MODULE,
  PLATFORM_CONFIG,
  SET_PLATFORM_CONFIG,
  GET_PLATFORM_CONFIG,
  SET_IS_LOADING,
  IS_LOADING,
  IS_ENABLED_OTP,
} = Constants.CONFIG_CONSTANTS;

export const ConfigMixin = {
  computed: {
    ...mapGetters(CONFIG_MODULE, [PLATFORM_CONFIG, IS_LOADING]),
    ...mapState(CONFIG_MODULE, ["phoneCode", "country", "phoneCodeList"]),
  },
  methods: {
    ...mapActions(CONFIG_MODULE, [
      "getAuthenticatedAppFeature",
      "getAppFeature",
      "getGeneralAppFeature",
      SET_PLATFORM_CONFIG,
      GET_PLATFORM_CONFIG,
      SET_IS_LOADING,
      IS_ENABLED_OTP,
    ]),
  },
};
